module.exports = __webpack_public_path__ + "img/m2.8f4e8413.png";